import { Route } from '@angular/router';
import { OrdersListComponent } from './components/orders-list/orders-list.component';
import { OrderExecutorFormComponent } from '@lib-ui/forms/order-executor-form/order-executor-form.component';

export const appRoutes: Route[] = [
    {
        path: '',
        redirectTo: 'orders-list',
        pathMatch: 'full',
    },
    {
        path: 'orders-list',
        component: OrdersListComponent,
    },
    {
        path: 'order-executor/:id',
        component: OrderExecutorFormComponent,
    },
];
